<template>
  <div
    class="border-b border-b-gray-200 dark:border-b-gray-800 px-4 py-3 text-gray-900 sm:rounded-t-md sm:px-5 sm:py-3"
  >
    <slot />
  </div>
</template>

<script setup lang="ts"></script>
